import { createGlobalStyle, GlobalStyleComponent } from "styled-components";

export const GlobalStyle = createGlobalStyle`
body {
    display: flex;
    justify-content: center;
  margin: 0;
  padding: 0;
  font-family: "Open Sans", sans-serif;
  text-transform: uppercase;
  text-decoration: none;



  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


/* HEADER */

.headerContainer{
  text-decoration: none;
  justify-content: center;

    display: flex;
    flex-direction: row;
    padding: 20px;
}

.headerContainer Link{
  text-decoration: none;

    padding: 5px;
    margin: 5px;
}

.headerTitle{

}

/* HOME */
.home{
  text-decoration: none;

    display: flex;
    flex-direction: column;
}

.home Link{
  text-decoration: none;

    margin: 20px;
    padding: 30px;


}

/* BORDER  */

.canvas {
  text-decoration: none;

  font-size: 16px;
  letter-spacing: 2px;
  color: #000;
  border: 3px solid;
  box-shadow: 1px 1px 0px 0px, 2px 2px 0px 0px, 3px 3px 0px 0px, 4px 4px 0px 0px, 5px 5px 0px 0px;
  padding: 8px;
  margin: 8px;
}

.canvas:active {
  box-shadow: 0px 0px 0px 0px;
  top: 5px;
  left: 5px;
}

img{
    width: 400px;
}

/* CONTAINERS */

.pageContainer{
    display: flex; 
    flex-direction: column; 
    height: 600px;
    padding: 10px;
}

.pageContainer div{
    padding: 10px;
}

.gallery{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

#root {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer{
    padding: 1px;
    position: sticky;
    justify-content: center;
    font-size: 10px;
    display: flex;
    bottom: 10;
    width: 300px;
}

.footer p{
    font-size: 7px;

}

.canvas p {
  padding:0;
  margin: 0;
  align-self: flex-end;
  display: flex;
  flex-direction: row;
  width: 200px;
}

.emoji{
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  flex-wrap: nowrap;
}

.emoji p {
  display: flex;
  width:25%
}

@media (max-width: 700px) { 

  #root {
    width: 500px;
  }

  .gallery{
    width: 200px
  }
  .img{
    width: 250px
  }
 }


`;
